import type { ApiErrorPayload } from "./types";

export const API_URL = process.env.NEXT_PUBLIC_API_URL ?? "http://localhost:4000/api/v1";

export class ApiError extends Error {
  constructor(public readonly status: number, public readonly payload: ApiErrorPayload) { super(payload.message); }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${API_URL}${path}`, {
    ...init,
    credentials: "include",
    headers: { "Content-Type": "application/json", Accept: "application/json", ...init?.headers },
  });
  if (!response.ok) {
    let payload: ApiErrorPayload = { code: `HTTP_${response.status}`, message: "Request failed" };
    try { payload = await response.json() as ApiErrorPayload; } catch { /* keep the safe generic error */ }
    throw new ApiError(response.status, payload);
  }
  return response.json() as Promise<T>;
}

export const money = (value: number, locale: "ru" | "kk" = "ru") => `${new Intl.NumberFormat(locale === "kk" ? "kk-KZ" : "ru-KZ").format(value)} ₸`;
export const dateTime = (value: string, locale: "ru" | "kk" = "ru") => new Intl.DateTimeFormat(locale === "kk" ? "kk-KZ" : "ru-KZ", { dateStyle: "medium", timeStyle: "short", timeZone: "Asia/Qyzylorda" }).format(new Date(value));
